import React from "react";
import { Table } from "reactstrap";
import {
  formatCurrency,
  formatInteger,
  occupancyPercent,
} from "./dashboardFormat";

// Produtos do evento: quanto vendeu, quanto ocupou e quanto rendeu.
//
// A receita é o valor PAGO rateado entre os produtos da compra (ver
// payment.dashboard.shape na admin-api), e não a multiplicação pelo preço de
// tabela: com cupom, as duas contas divergem, e a que interessa é a que entrou.

export default function ProductsTable({ products = [] }) {
  if (products.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhum produto cadastrado para este evento.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table className="table-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th style={{ fontWeight: 500, color: "#74788d" }}>Produto</th>
            <th style={{ fontWeight: 500, color: "#74788d", width: "260px" }}>Ocupação</th>
            <th style={{ fontWeight: 500, color: "#74788d" }}>Vendidos</th>
            {/* Dinheiro à direita, como na tela de Vendas Consolidadas: os
                valores terminam na mesma coluna e comparam-se de cima a baixo. */}
            <th className="text-end" style={{ fontWeight: 500, color: "#74788d" }}>
              Receita
            </th>
            <th style={{ fontWeight: 500, color: "#74788d" }}>Últimos 7 dias</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => {
            const percent = occupancyPercent(product);

            return (
              <tr key={product.id}>
                <td style={{ fontWeight: 600, color: "#1f2937" }}>{product.description}</td>
                <td>
                  {percent === null ? (
                    <span className="text-muted">sem limite</span>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div style={{ flexGrow: 1, height: "8px", background: "#eff2f7", borderRadius: "4px" }}>
                        <div
                          style={{
                            width: `${percent}%`,
                            height: "8px",
                            background: "#556ee6",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                      <span style={{ fontSize: "11.5px", color: "#74788d", width: "38px", textAlign: "right" }}>
                        {percent}%
                      </span>
                    </div>
                  )}
                </td>
                <td>
                  {formatInteger(product.sold)}
                  {product.available !== null && (
                    <span className="text-muted"> / {formatInteger(product.available)}</span>
                  )}
                </td>
                <td
                  className="text-end text-nowrap"
                  style={{ fontWeight: 600, color: "#1f2937", fontVariantNumeric: "tabular-nums" }}
                >
                  {formatCurrency(product.revenue)}
                </td>
                <td>{product.soldLast7Days > 0 ? `+${formatInteger(product.soldLast7Days)}` : "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
